import { createAction } from '@reduxjs/toolkit';
export const INITIATE_CALL = 'INITIATE_CALL';
export const initiateCallAction = createAction(INITIATE_CALL);